import { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Index from "./Pages/index.js";
import About from "./Pages/About.js";
import CompPage from './Pages/CompPage'
import CompeInside from './Pages/CompeInsidePages/CompeInside'
import ScoreBoard from "./Components/ScoreBoard.js";
import AdminScore from "./Components/ScoreBoardList/AdminScore.js";
import Login from "./Components/Login/Login.js";
import AddScore from "./Components/ScoreBoardList/addScore.js";
import EditScore from "./Components/ScoreBoardList/editScore.js";

function App() {

    const [isLoggedIn, setIsLoggedIn] = useState()
    const [url, setUrl] = useState()


    useEffect(() => {
        setUrl(window.location.pathname)
        console.log(window.location.pathname)
    }, [window.location.pathname])


    const CompeData = [
        {
            id: "1",
            name: "Badminton",
            path: "Badminton",
            description: `Don’t care ‘bout what they say.
            Just be sure to practice.
            Buckle up and smash your way.
            As SMAKONECUP 2023 badminton competition is at your service!
            `,
            class: "Badminton",
            smallclass: "BadmintonSmall",
            rules: "",
            coord1: "Margaret (08118133478)",
            line1: "margaretmu",
            coord2: "Riovalen (0895375547467)",
            line2: "riovalenwijaya",
            tm: "20 Oktober 2023",
            start: "25 Oktober 2023",
            coverImg: "Badminton.webp"
        },
        {
            id: "2",
            name: "Band",
            path: "Band",
            description: `In the heart of rhythm, let’s take our stand.
            A group of souls is united in band.
            With instruments in hand, we come alive.
            Sharing music, make hearts thrive`,
            class: "Band",
            smallclass: "BandSmall",
            rules: "",
            coord1: "Rafael Valerian (081370719999)",
            line1: "rafaelvalerian",
            coord2: "Tyra Ellena (081317631032)",
            line2: "tyraellena",
            tm: "24 Oktober 2023",
            start: "01 November 2023",
            coverImg: "BAND.webp"
        },
        {
            id: "3",
            name: "Basket",
            path: "Basket",
            description: `Throw the ball and win the game!
            Can’t you feel the burning flame?
            Trust your gut and trust your aim.
            Not competing here with us would be a shame.
            
            So, come and join our basketball competition at #SMAKONECUP2023!`,
            class: "Basket",
            smallclass: "BasketSmall",
            rules: "",
            coord1: "Max (085737045858)",
            line1: "maximilianhendrawan",
            coord2: "Cia (08151626999)",
            line2: "etrishelle",
            tm: "20 Oktober 2023",
            start: "24 Oktober 2023",
            coverImg: "basket.webp"
        },
        {
            id: "4",
            name: "Business Plan",
            path: "Business-Plan",
            description: `A space that nurtures innovation, 🤔💡
            Building a legacy that lasts a lifetime🤝🏻
            Your idea, our competition, the world's attention🧠
            With a plan comes power, it’s your sign to join #HORIZON2023’s Business Plan and shine brighter! 💯🚀✨`,
            class: "Business",
            smallclass: "BusinessSmall",
            rules: "",
            coord1: "Ferlyn (085104989988)",
            line1: "ferlynnnsutejooo",
            coord2: "Chloe (085282657214)",
            line2: "chloecharlottee",
            tm: "18 Oktober 2023",
            start: "28 Oktober 2023",
            coverImg: "business-plan.webp"
        },
        {
            id: "5",
            name: "English Debate",
            path: "English-Debate",
            description: `Compete to be complete, it’s a battle of minds🎯.
            A chance to scheme and achieve your dream🤩🌈.
            So now the debate begins💥.
            Time to think, speak, and win🏆!
            By joining #SMAKONECUP2023 to spread your wings!🏹`,
            class: "EDS",
            smallclass: "EDSSmall",
            rules: "",
            coord1: "Selina Septine (085711907370)",
            line1: "selinaseptine",
            coord2: "Daphne Angelene (089663984145)",
            line2: "daph0312",
            tm: "20 Oktober 2023",
            start: "25 Oktober 2023",
            coverImg: "eds.webp"
        },
        {
            id: "6",
            name: "Photography",
            path: "Photography",
            description: `In the world of frames, where vision takes flight ✈️
            Capture the Horizon, in its golden light.
            In this photo battle, let your talents shine.
            As we explore the Horizon, one click at the time.`,
            class: "Fotografi",
            smallclass: "FotografiSmall",
            rules: "",
            coord1: "Stephanie Selina (081510762543)",
            line1: "steph.s.s",
            coord2: "Aurelia Carmen (082314102255)",
            line2: "aureliacarmenn",
            tm: "20 Oktober 2023",
            start: "25 Oktober 2023",
            coverImg: "fotografi.webp"
        },
        {
            id: "7",
            name: "Futsal",
            path: "Futsal",
            description: `Thrilling and exciting matches are ahead.
            You can’t let doubts fill your head.
            Join us and play the game instead.
            Be the player and make them scared!
            `,
            class: "Futsal",
            smallclass: "FutsalSmall",
            rules: "",
            coord1: "Jason (0895381890028)",
            line1: "01342096",
            coord2: "Matthew (085772424240)",
            line2: "126621nolan",
            tm: "20 Oktober 2023",
            start: "24 Oktober 2023",
            coverImg: "futsal.webp"
        },
        {
            id: "8",
            name: "JHS IPA",
            path: "JHS-IPA",
            description: `Smart like Carolus Linnaeus.
            Be the next Einstein!
            In Science, It’s not just about ideas,
            but it’s about making ideas happen.`,
            class: "IPA",
            smallclass: "IPASmall",
            rules: "",
            coord1: "Erin Larasati (089670808306)",
            line1: "viscarialol",
            coord2: "William Christian (08170913755)",
            line2: "will20102006",
            tm: "25 Oktober 2023",
            start: "27 Oktober 2023",
            coverImg: "IPA.webp"
        },
        {
            id: "9",
            name: "JHS IPS",
            path: "JHS-IPS",
            description: `In life, we need to understand how to interact with other people.
            But what is more important is that we have to know about history,
            Because understanding the past helps us to understand the future.
            In SMAKONECUP2023, together we can make a beautiful history!!`,
            class: "IPS",
            smallclass: "IPSSmall",
            rules: "",
            coord1: "Elliora Alesha (081805788999)",
            line1: "ellioralesha",
            coord2: "Aurelia Dominique (081578797428)",
            line2: "aureliadominiique",
            tm: "26 Oktober 2023",
            start: "27 Oktober 2023",
            coverImg: "ips.webp"
        },
        {
            id: "10",
            name: "JHS Matematika",
            path: "JHS-Matematika",
            description: `In Junior High, math minds soar high.
            In competitions, they reach for the sky.
            Numbers dance, equations gleam!
            In math battles, they chase the dream!
            `,
            class: "Matematika",
            smallclass: "MatematikaSmall",
            rules: "",
            coord1: "Evan Aristo (081932223755)",
            coord2: "Darren Mikael (08119127977)",
            line2: "darren_mikael_c",
            tm: "18 Oktober 2023",
            start: "25 Oktober 2023",
            coverImg: "Matematika.webp"
        },
        {
            id: "11",
            name: "Modern Dance",
            path: "Modern-Dance",
            description: `A fusion of styles, a fusion of hearts.
            Where creativity is where it all starts.
            Express your feelings, bold and free.
            Create an amazing sight to see.`,
            class: "modern",
            smallclass: "modernSmall",
            rules: "",
            coord1: "Florentina Gwendolyn (089621408649)",
            line1: "florentina_0328",
            coord2: "Nadine Felicity (0816891372)",
            line2: "nadine.felicity",
            tm: "19 Oktober 2023",
            start: "02 November 2023",
            coverImg: "MD.webp"
        },
        {
            id: "12",
            name: "Model United Nation",
            path: "Model-United-Nation",
            description: `Hey all delegates!
            You who knows all the global issues!
            It’s time for you to debate and negotiate.
            Prepare yourself, win it and celebrate!`,
            class: "MUN",
            smallclass: "MUNSmall",
            rules: "",
            coord1: "Brandon Masson (081280627467)",
            line1: "massonbrandon",
            coord2: "Grace Josephine (081210931431)",
            line2: "gracejosephinnee",
            tm: "20 Oktober 2023",
            start: "27 Oktober 2023",
            coverImg: "MUN.webp"
        },
        {
            id: "13",
            name: "Mural",
            path: "Mural",
            description: `🧑🏻‍🎨In this mural creation,
            where colours are blent.
            Horizon comes alive, beyond expectation.
            A masterpiece is sent!`,
            class: "Mural",
            smallclass: "MuralSmall",
            rules: "",
            coord1: "Jennessa Kusumo (082288822240)",
            line1: "jennessa_00",
            coord2: "Priscilla J. Liem (081295083039)",
            line2: "ychrime_",
            tm: "23 Oktober 2023",
            start: "28 Oktober 2023",
            coverImg: "Mural.webp"
        },
        {
            id: "14",
            name: "Short Movie",
            path: "Short-Movie",
            description: `Lights, camera, action!
            It is time for you to show off your passion.
            By joining short movie competition,
            In HORIZON2023, beyond imagination!`,
            class: "Short",
            smallclass: "ShortSmall",
            rules: "",
            coord1: "Charmaine Dominique (08158100288)",
            line1: "charmainedomirique",
            tm: "20 Oktober 2023",
            start: "31 Oktober 2023",
            coverImg: "shortmovie.webp"
        },
        {
            id: "15",
            name: "Speech Competition",
            path: "Speech-Competition",
            description: `In the spotlight, words take flight, no inhibition.
            At SOC’s speech competition, it's a verbal expedition.
            With confidence and passion, we seek recognition,
            In this lyrical battle of verbal ammunition.
            `,
            class: "Speech",
            smallclass: "SpeechSmall",
            rules: "",
            coord1: "Nathaline",
            line1: "nathaline23",
            coord2: "Clarissa (081213068596)",
            tm: "24 Oktober 2023",
            start: "30 Oktober 2023",
            coverImg: "speech.webp"
        },
        {
            id: "16",
            name: "Voli",
            path: "Voli",
            description: `Through the net!
            Try to make the best out of it.
            Don’t be late and forget!
            Register yourselves at #SMAKONECUP2023 where you can compete!`,
            class: "Voli",
            smallclass: "VoliSmall",
            rules: "",
            coord1: "Dylan Setyono (081272727808)",
            line1: "dylansetyono",
            coord2: "Eileen Elton (0811957579)",
            line2: "eileenelton0310",
            tm: "20 Oktober 2023",
            start: "24 Oktober 2023",
            coverImg: "Voli.webp"
        }
      ]

    const setLogin = (bool) => {
        setIsLoggedIn(bool)
    }

  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<ScoreBoard />} />
        <Route path='/scoreboard' element={<ScoreBoard />} />
        <Route path='/login' element={<Login setLogin={setLogin}/>} />
        { isLoggedIn ? 
            <Route path='/admin' element={<AdminScore/>}/>
        : null }
        { isLoggedIn ? 
            <Route path="/admin/add" element={<AddScore/>}/>
        : null }
        { isLoggedIn ? 
            <Route path="/admin/edit/:id" element={<EditScore/>}/>
        : null }
        
           



        { !isLoggedIn && url == "/admin" ? <Route path='/admin' element={<Login setLogin={setLogin}/>}/> : null }
        { !isLoggedIn && url == "/admin/add" ? <Route path='/admin/add' element={<Login setLogin={setLogin}/>}/> : null }
        { !isLoggedIn && url == "/admin/edit/:id" ? <Route path='/admin/edit/:id' element={<Login setLogin={setLogin}/>}/> : null }


        <Route path="/about" element={<About />}/>
          <Route path='/competition' element={<CompPage />}/>
          <Route path='/competition/Badminton' element={<CompeInside map={CompeData[0]} />}/>
          <Route path='/competition/Band' element={<CompeInside map={CompeData[1]} />}/>
          <Route path='/competition/Basket' element={<CompeInside map={CompeData[2]} />}/>
          <Route path='/competition/Business-Plan' element={<CompeInside map={CompeData[3]} />}/>
          <Route path='/competition/English-Debate' element={<CompeInside map={CompeData[4]} />}/>
          <Route path='/competition/Fotografi' element={<CompeInside map={CompeData[5]} />}/>
          <Route path='/competition/Futsal' element={<CompeInside map={CompeData[6]} />}/>
          <Route path='/competition/JHS-IPA' element={<CompeInside map={CompeData[7]} />}/>
          <Route path='/competition/JHS-IPS' element={<CompeInside map={CompeData[8]} />}/>
          <Route path='/competition/JHS-Matematika' element={<CompeInside map={CompeData[9]} />}/>
          <Route path='/competition/Modern-Dance' element={<CompeInside map={CompeData[10]} />}/>
          <Route path='/competition/Model-United-Nation' element={<CompeInside map={CompeData[11]} />}/>
          <Route path='/competition/Mural' element={<CompeInside map={CompeData[12]} />}/>
          <Route path='/competition/Short-Movie' element={<CompeInside map={CompeData[13]} />}/>
          <Route path='/competition/Speech-Competition' element={<CompeInside map={CompeData[14]} />}/>
          <Route path='/competition/Voli' element={<CompeInside map={CompeData[15]} />}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
